<template>
  <div class="pupils">
    <header class="px-6 mx-4">
      <div class="flex justify-between">
        <div>
          <h2 class="text-xl font-semibold w-64 inline-block">Pupil Voice</h2>
          <div class="text-gray-500 pb-4">
            Please select a pupil to view the timeline.
          </div>
        </div>
        <div>
          <div class="flex">
            <input
              type="search"
              class="filter-bar-search focus:outline-none w-56 ml-4"
              name="search"
              v-model="search"
              placeholder="Search pupils..."
            />
            <i
              class="fas fa-times text-sm absolute -ml-8 mt-4 cursor-pointer hover:opacity-50"
              @click="search = ''"
              title="Clear search"
              v-show="search.length > 0"
            ></i>
          </div>
        </div>
      </div>
    </header>

    <pupilsselect
      @pupil-selected="selectPupil"
      :orderedPupils="pupils"
      :inputSearch="search"
      v-if="!loading"
    >
    </pupilsselect>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { PupilService } from "@/services/pupil.service";

const pupilsselect = () => import("@/components/PupilsGridSelect.vue");

export default {
  name: "pupils",
  props: ["filterValues"],
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
      settings: "settings",
    }),
  },
  data() {
    return {
      pupils: [],
      loading: true,
      errored: false,
      search: "",
      filteredTags: [],
    };
  },
  created() {},
  mounted() {
    this.searchPupils();
  },
  watch: {
    $props: {
      handler: function (val, oldVal) {
        this.searchPupils();
      },
      deep: true,
    },
  },
  methods: {
    searchPupils() {
      this.loading = true;

      PupilService.getWithFilter(this.filterValues, 1, 5000)
        .then((response) => (this.pupils = response.data.data))
        .catch((err) => {
          console.log("pupils " + err);
          this.errored = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    selectPupil(pupil) {
      this.$router.push({
        name: "WellbeingQuestions",
        params: { pupil: pupil },
      });
      window.scrollTo(0, 0);
    },
  },
  components: {
    pupilsselect,
  },
};
</script>
